var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgActivity = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M15,18.6282918 L9.71151247,2.76282918 C9.4835884,2.07905694 8.5164116,2.07905694 8.28848753,2.76282918 L5.45943058,11.25 L2,11.25 C1.58578644,11.25 1.25,11.5857864 1.25,12 C1.25,12.4142136 1.58578644,12.75 2,12.75 L6,12.75 C6.32282281,12.75 6.60942694,12.5434274 6.71151247,12.2371708 L9,5.37170825 L14.2884875,21.2371708 C14.5164116,21.9209431 15.4835884,21.9209431 15.7115125,21.2371708 L18.5405694,12.75 L22,12.75 C22.4142136,12.75 22.75,12.4142136 22.75,12 C22.75,11.5857864 22.4142136,11.25 22,11.25 L18,11.25 C17.6771772,11.25 17.3905731,11.4565726 17.2884875,11.7628292 L15,18.6282918 Z"
  }));
};
export default SvgActivity;